import { Link, useLocation } from "react-router-dom";
import { useApp } from "@/lib/AppContext";

const T = {
  ar: { home: "الرئيسية", wheel: "العجلة", order: "اطلب المندوب", about: "من نحن", contact: "تواصل" },
  en: { home: "Home", wheel: "Wheel", order: "Order", about: "About", contact: "Contact" }
};

function NavItem({ label, href, icon, active }) {
  return (
    <Link to={href} className="flex flex-col items-center gap-1 px-1.5 py-1 flex-1 min-w-0">
      <span className={`text-xl leading-none transition-all duration-200 ${active ? "scale-110 grayscale-0" : "grayscale opacity-60"}`}>{icon}</span>
      <span className={`text-[10px] font-bold truncate max-w-full transition-colors ${active ? "text-primary" : "text-muted-foreground"}`}>{label}</span>
    </Link>
  );
}

export default function MobileBottomNav() {
  const { lang } = useApp();
  const tr = T[lang] || T.ar;
  const location = useLocation();

  const isActive = (href) => (href === "/" ? location.pathname === "/" : location.pathname.startsWith(href));

  const items = [
    { label: tr.home, href: "/", icon: "🏠" },
    { label: tr.wheel, href: "/wheel", icon: "🎡" },
    { label: tr.about, href: "/about", icon: "ℹ️" },
    { label: tr.contact, href: "/contact", icon: "📞" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-background/95 backdrop-blur-md border-t border-border safe-bottom">
      <div className="flex items-end justify-around px-1 pt-2 pb-2">
        {items.slice(0, 2).map(item => (
          <NavItem key={item.href} {...item} active={isActive(item.href)} />
        ))}

        {/* Prominent center Order button */}
        <Link to="/laundry" className="flex flex-col items-center gap-1 -mt-7 flex-shrink-0">
          <div className="w-16 h-16 rounded-full overflow-hidden bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-xl ring-4 ring-background pulse-glow active:scale-95 transition-transform">
            <img src="https://media.base44.com/images/public/6a2b1e20f315b54cdcedf465/a0816ac66_generated_image.png" alt="مندوب التوصيل" width="64" height="64" loading="lazy" decoding="async" className="w-full h-full object-cover" />
          </div>
          <span className="text-[10px] font-black text-primary leading-none">{tr.order}</span>
        </Link>

        {items.slice(2).map(item => (
          <NavItem key={item.href} {...item} active={isActive(item.href)} />
        ))}
      </div>
    </nav>
  );
}